// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2201":"52e8a12a","6040":"e7f832fd","7877":"e7f832fd"}[chunkId] + ".chunk.css";
};